import { EventType } from 'matrix-js-sdk/src';

// https://github.com/matrix-org/matrix-react-sdk/blob/cd15e08fc285da42134817cce50de8011809cd53/src/utils/blobs.ts
export const IMAGE_TYPES = ['image/jpeg', 'image/gif', 'image/png', 'image/apng', 'image/webp', 'image/avif'];

export const ALLOWED_BLOB_MIMETYPES = [
  ...IMAGE_TYPES,
  'video/mp4',
  'video/webm',
  'video/ogg',
  'video/quicktime',
  'audio/mp4',
  'audio/webm',
  'audio/aac',
  'audio/mpeg',
  'audio/ogg',
  'audio/wave',
  'audio/wav',
  'audio/x-wav',
  'audio/x-pn-wav',
  'audio/flac',
  'audio/x-flac',
];

export const MAX_FETCH_ATTEMPTS_COUNT = 5;
export const TIMEOUT_BETWEEN_RETRIES_MS = 2000;
export const INITIAL_MESSAGES_COUNT = 20;
export const MAX_INITIAL_MESSAGES_COUNT = 200;
export const FETCH_MESSAGES_LIMIT = 20;
/** Stop backfilling messenger timeline once this many decryption failures are loaded. */
export const MAX_UNDECRYPTABLE_MESSAGES_TIMELINE = 100;
export const MESSAGES_FILTER = {
  room: {
    timeline: {
      types: [
        EventType.RoomMessage,
        EventType.RoomMessageEncrypted,
        'eu.meedio.messenger.scheduled_meeting',
        'eu.meedio.messenger.meeting_started',
      ],
    },
  },
};

export const PREFETCH_THRESHOLD_PX = 500;
export const READ_RECEIPT_DEBOUNCE_MS = 500;
export const SPINNER_HEIGHT = 32;
export const PIXEL_THRESHOLD_VALUE_FOR_ATTACHMENT_SCROLL = 60;
export const PIXEL_THRESHOLD_VALUE_FOR_SCROLL = 600;
export const CONTENT_SETTLE_DELAY_MS = 100;
export const MAX_CONTENT_READY_WAIT_MS = 3000;
export const BYTES_PER_MB = 1000000;
export const FILE_SIZE_LIMIT_MB = 1024;
export const TEXT_AREA_VERTICAL_PADDING = 17;
export const textAreaConstants = {
  MIN_MESSAGE_ROWS: 1,
  MAX_MESSAGE_ROWS: 3,
  TEXTAREA_LINE_HEIGHT: 21,
};
